import Image from 'next/image';

const UXCoreGray = () => (
  <Image
    src="/keepsimple_/assets/home-page/uxcore-gray.png"
    alt="UX Core Gray"
    width={70}
    height={70}
  />
);

export default UXCoreGray;
